import React from "react";
import Search from '../components/Search'

export default class HomeView extends React.Component {
    render() {
        return (
            <div>
                <Search/>
            </div>
        );
    }
}
